import { render, staticRenderFns } from "./contentUserAllGroupDelete.vue?vue&type=template&id=3899b1c5&"
import script from "./contentUserAllGroupDelete.vue?vue&type=script&lang=js&"
export * from "./contentUserAllGroupDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports